
const NotFoundPage = () => (
  <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
    <h1 style={{ fontSize: 48, color: "#003566" }}>404</h1>
    <h2 style={{ fontSize: 24, marginBottom: 16 }}>Página no encontrada</h2>
    <p>La página que buscas no existe o ha sido movida.</p>
  </div>
);

export default NotFoundPage;
